(function () {
  /**
   * Anima una miniatura de la prenda "volando" desde la tarjeta hasta el
   * icono del carrito en el header. Puramente visual -- no afecta el
   * carrito real, que ya se actualizo antes via /cart/add.js.
   * @param {Element} card
   * @param {Element} btn
   */
  function flyToCart(card, btn) {
    var img = card.querySelector('.cheij-carousel__media img');
    var cartIcon = document.querySelector('[data-testid="cart-drawer-trigger"], a[href="/cart"]');
    if (!img || !cartIcon) return;

    var startRect = btn.getBoundingClientRect();
    var endRect = cartIcon.getBoundingClientRect();

    var clone = img.cloneNode(true);
    clone.style.position = 'fixed';
    clone.style.left = startRect.left + 'px';
    clone.style.top = startRect.top + 'px';
    clone.style.width = startRect.width + 'px';
    clone.style.height = startRect.width + 'px';
    clone.style.objectFit = 'cover';
    clone.style.borderRadius = '50%';
    clone.style.zIndex = '9999';
    clone.style.pointerEvents = 'none';
    clone.style.willChange = 'transform, opacity';
    document.body.appendChild(clone);

    var dx = (endRect.left + endRect.width / 2) - (startRect.left + startRect.width / 2);
    var dy = (endRect.top + endRect.height / 2) - (startRect.top + startRect.height / 2);

    var animation = clone.animate(
      [
        { transform: 'translate(0, 0) scale(1)', opacity: 1 },
        { transform: 'translate(' + (dx * 0.5) + 'px, ' + (dy * 0.5 - 70) + 'px) scale(0.7)', opacity: 1, offset: 0.55 },
        { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(0.15)', opacity: 0 }
      ],
      { duration: 650, easing: 'cubic-bezier(0.3, 0, 0.6, 1)' }
    );

    animation.onfinish = function () {
      clone.remove();
    };
  }

  /** @param {Element} root */
  function initCarousel(root) {
    var track = root.querySelector('[data-carousel-track]');
    var prevBtn = root.querySelector('[data-carousel-prev]');
    var nextBtn = root.querySelector('[data-carousel-next]');
    if (!track) return;

    function cardWidth() {
      var card = track.querySelector('.cheij-carousel__card');
      return card ? card.getBoundingClientRect().width + 1 : track.clientWidth;
    }

    function updateNavState() {
      if (!prevBtn || !nextBtn) return;
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -cardWidth(), behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: cardWidth(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateNavState, { passive: true });
    window.addEventListener('resize', updateNavState);
    updateNavState();

    // Arrastre con mouse en desktop (el touch ya scrollea nativo).
    // Si el click empieza sobre un <a> o <button>, no iniciamos el drag
    // ni capturamos el puntero -- si no, el navegador nunca deja pasar
    // el click real a esos elementos.
    var isDown = false;
    var startX = 0;
    var startScroll = 0;

    track.addEventListener('pointerdown', /** @param {PointerEvent} e */ function (e) {
      if (e.pointerType === 'touch') return;
      if (e.target.closest('a, button')) return;
      isDown = true;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      track.setPointerCapture(e.pointerId);
    });

    track.addEventListener('pointermove', /** @param {PointerEvent} e */ function (e) {
      if (!isDown) return;
      track.scrollLeft = startScroll - (e.clientX - startX);
    });

    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (evt) {
      track.addEventListener(evt, function () {
        isDown = false;
      });
    });

    // Selector de cantidad -- un contador propio por tarjeta (min. 1).
    root.querySelectorAll('.cheij-carousel__card').forEach(/** @param {Element} card */ function (card) {
      var qtyValue = card.querySelector('[data-qty-value]');
      var decreaseBtn = card.querySelector('[data-qty-decrease]');
      var increaseBtn = card.querySelector('[data-qty-increase]');
      if (!qtyValue || !decreaseBtn || !increaseBtn) return;

      function getQty() {
        return parseInt(qtyValue.textContent, 10) || 1;
      }

      function setQty(value) {
        qtyValue.textContent = String(Math.max(1, value));
      }

      decreaseBtn.addEventListener('click', function () {
        setQty(getQty() - 1);
      });

      increaseBtn.addEventListener('click', function () {
        setQty(getQty() + 1);
      });
    });

    // Agregar al carrito via Shopify.actions.updateCart() -- la "standard
    // storefront action" del tema. A diferencia de pegarle directo a
    // /cart/add.js y despues nosotros reemplazar el innerHTML del drawer
    // a mano, esta funcion deja que el propio tema haga el refresco
    // interno de forma nativa, manteniendo sincronizados los refs/indices
    // de cada linea del carrito. Tocar el DOM del drawer nosotros mismos
    // era lo que rompia ese tracking y causaba que al borrar un producto
    // se borraran en cadena los que estaban debajo.
    root.querySelectorAll('[data-add-to-cart]').forEach(/** @param {Element} btn */ function (btn) {
      btn.addEventListener('click', function () {
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId || btn.classList.contains('is-loading')) return;

        var card = btn.closest('.cheij-carousel__card');
        var qtyValue = card ? card.querySelector('[data-qty-value]') : null;
        var quantity = qtyValue ? (parseInt(qtyValue.textContent, 10) || 1) : 1;

        btn.classList.add('is-loading');

        if (!window.Shopify || !window.Shopify.actions || !window.Shopify.actions.updateCart) {
          // Fallback por si el tema todavia no expone las standard actions
          // (version vieja de Fabric). En ese caso avisamos por consola en
          // vez de romper la pagina.
          btn.classList.remove('is-loading');
          console.warn('CHEIJ: Shopify.actions.updateCart no disponible en este tema.');
          return;
        }

        Shopify.actions
          .updateCart({
            lines: [
              {
                merchandiseId: 'gid://shopify/ProductVariant/' + variantId,
                quantity: quantity
              }
            ]
          })
          .then(function (result) {
            btn.classList.remove('is-loading');

            if (result && result.userErrors && result.userErrors.length) {
              console.warn('CHEIJ: no se pudo agregar al carrito', result.userErrors);
              return;
            }

            btn.classList.add('is-added');
            if (qtyValue) qtyValue.textContent = '1';
            flyToCart(card, btn);

            setTimeout(function () {
              btn.classList.remove('is-added');
            }, 1200);
          })
          .catch(function () {
            btn.classList.remove('is-loading');
          });
      });
    });
  }

  document.querySelectorAll('[data-cheij-carousel]').forEach(initCarousel);
})();
